<template>
  <section class="p-2">
    <v-card flat class="ms-4 me-4">
      <v-card class="ma-2" flat>
        <span class="lighten-2 pa-2"> Key Values </span>
        <v-divider class="m-0 p-0"></v-divider>
        <v-form ref="form" v-model="valid">
          <v-card-text class="cardtext-width">
            <v-row no-gutters class="d-flex justify-space-between">
              <v-col class="mt-2" cols="12" md="5"> Country code</v-col>
              <v-col class="d-flex" cols="12" md="2">
                <v-text-field
                  placeholder="Country code"
                  class="rounded"
                  required
                  disabled
                  outlined
                  dense
                  v-model="Mandatorycheckskeysvalues.country_code"
                />
              </v-col>
            </v-row>
            <v-row no-gutters class="d-flex justify-space-between">
              <v-col class="mt-2" cols="12" md="5"> Telephone code</v-col>
              <v-col class="d-flex" cols="12" md="4">
                <v-text-field
                  placeholder="Telephone code"
                  class="rounded"
                  required
                  outlined
                  disabled
                  dense
                  v-model="Mandatorycheckskeysvalues.telephone_code"
                />
              </v-col>
            </v-row>
            <v-row no-gutters class="d-flex justify-space-between">
              <v-col class="mt-2 required" cols="12" md="5">
                Telephone Length</v-col
              >
              <v-col class="d-flex" cols="12" md="4">
                <v-text-field
                  placeholder="Min"
                  class="rounded pe-2"
                  required
                  outlined
                  type="number"
                  hide-spin-buttons
                  @keydown="nodotNumber"
                  dense
                  :rules="numbersOnly"
                  v-model="Mandatorycheckskeysvalues.telephone_length_min"
                />
                <v-text-field
                  placeholder="Max"
                  type="number"
                  class="rounded"
                  hide-spin-buttons
                  @keydown="nodotNumber"
                  required
                  outlined
                  dense
                  :rules="numbersOnly"
                  v-model="Mandatorycheckskeysvalues.telephone_length_max"
                />
              </v-col>
            </v-row>
            <v-row no-gutters class="d-flex justify-space-between">
              <v-col class="mt-2" cols="12" md="5"> ISO2</v-col>
              <v-col class="d-flex" cols="4" md="2">
                <v-text-field
                  placeholder="ISO2"
                  class="rounded"
                  required
                  outlined
                  dense
                  disabled
                  v-model="Mandatorycheckskeysvalues.iso2"
                />
              </v-col>
            </v-row>
            <v-row no-gutters class="d-flex justify-space-between">
              <v-col class="mt-2" cols="12" md="5"> ISO3</v-col>
              <v-col class="d-flex" cols="12" md="2">
                <v-text-field
                  placeholder="ISO3"
                  class="rounded"
                  required
                  outlined
                  dense
                  disabled
                  v-model="Mandatorycheckskeysvalues.iso3"
                />
              </v-col>
            </v-row>
            <v-row no-gutters class="d-flex justify-space-between">
              <v-col class="mt-2" cols="12" md="5"> Currency code</v-col>
              <v-col class="d-flex" cols="12" md="4">
                <v-text-field
                  placeholder="Currency code"
                  class="rounded"
                  required
                  outlined
                  dense
                  disabled
                  v-model="Mandatorycheckskeysvalues.currency_code"
                />
              </v-col>
            </v-row>
            <v-row no-gutters class="d-flex justify-space-between">
              <v-col class="mt-2 required" cols="12" md="5">
                Sanction Filter(%)</v-col
              >
              <v-col cols="12" md="4">
                <v-text-field
                  placeholder="Sanction Filter"
                  class="rounded width__input"
                  required
                  outlined
                  type="number"
                  hide-spin-buttons
                  @keydown="filterNumberInput"
                  dense
                  :rules="sanctionFilter"
                  v-model="Mandatorycheckskeysvalues.sanction_filter"
                />
              </v-col>
            </v-row>
            <v-row no-gutters class="d-flex justify-space-between">
              <v-col class="mt-2 required" cols="12" md="5">
                Bank Account Number Length</v-col
              >
              <v-col class="d-flex" cols="12" md="4">
                <v-text-field
                  placeholder="Min"
                  class="rounded pe-2"
                  required
                  outlined
                  type="number"
                  hide-spin-buttons
                  @keydown="nodotNumber"
                  dense
                  :rules="bankAccount"
                  v-model="Mandatorycheckskeysvalues.bank_ac_length_min"
                />
                <v-text-field
                  placeholder="Max"
                  class="rounded"
                  required
                  outlined
                  type="number"
                  hide-spin-buttons
                  @keydown="nodotNumber"
                  dense
                  :rules="bankAccount"
                  v-model="Mandatorycheckskeysvalues.bank_ac_length_max"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
      <v-card class="ma-2" flat>
        <span class="lighten-2 pa-2"> Mandatory Values </span>
        <v-divider class="m-0 p-0"></v-divider>
        <v-form ref="Mandatory" valid="true">
          <v-card-text class="cardtext-width">
            <v-row no-gutters class="d-flex justify-space-between">
              <v-col class="mt-2 required" cols="12" md="5">
                Payment Modes</v-col
              >
              <v-col class="d-flex" cols="12" md="5">
                <v-select
                  v-model="mandatoryValues.value_list"
                  :items="paymentList"
                  :rules="paymentMode"
                  outlined
                  class="rounded"
                  placeholder="Payment Modes"
                  dense
                  chips
                  small-chips
                  multiple
                  item-text="txt"
                  item-value="val"
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters class="d-flex justify-space-between">
              <v-col class="mt-2 required" cols="12" md="5"> Risk Type</v-col>
              <v-col class="d-flex" cols="12" md="5">
                <v-select
                  v-model="Mandatorycheckskeysvalues.risk_type_code"
                  :items="risk_types"
                  :rules="riskType"
                  outlined
                  class="rounded"
                  placeholder="Risk Type"
                  dense
                  item-text="txt"
                  item-value="val"
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters class="d-flex justify-space-between">
              <v-col class="mt-2 required" cols="12" md="5">
                Partner Type</v-col
              >
              <v-col class="d-flex" cols="12" md="5">
                <v-select
                  v-model="mandatoryValuespartners.value_list"
                  :items="partner_types"
                  :rules="partnerType"
                  outlined
                  class="rounded"
                  placeholder="Partner Type"
                  dense
                  chips
                  small-chips
                  multiple
                  item-text="txt"
                  item-value="val"
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters class="d-flex justify-space-between">
              <v-col class="mt-2 required" cols="12" md="5"> Time Zone</v-col>
              <v-col class="d-flex" cols="12" md="5">
                <v-autocomplete
                  v-model="Mandatorycheckskeysvalues.time_zone"
                  :items="time_zones"
                  :rules="timezone"
                  outlined
                  placeholder="Time Zone"
                  class="rounded"
                  dense
                  item-text="txt"
                  item-value="val"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>

      <v-card class="" flat>
        <span class="lighten-2 pa-2"> Mandatory Checks </span>
        <v-divider class="m-0 p-0"></v-divider>
        <v-card-text class="cardtext-width">
          <v-row no-gutters class="d-flex justify-space-between">
            <v-col class="mt-4" cols="10"> States Mandatory</v-col>
            <v-col class="d-flex justify-end" cols="2">
              <v-checkbox
                v-model="Mandatorycheckskeysvalues.is_states_mandatory"
                color="primary"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row no-gutters class="d-flex justify-space-between">
            <v-col class="mt-4" cols="10">Bank Branch Code </v-col>
            <v-col class="d-flex justify-end" cols="2">
              <v-checkbox
                v-model="Mandatorycheckskeysvalues.is_bb_code_Mandatory"
                color="primary"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-space-between">
            <v-col class="d-flex" cols="12">
              <v-text-field
                label="Remarks"
                class="rounded pe-2"
                hint="*Above remarks will be visible in customer User Portal"
                required
                outlined
                dense
                v-model="Mandatorycheckskeysvalues.bb_remarks"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="m-0 p-0"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary"
            class="text-capitalize"
            small
            @click="saveMandatory"
          >
            Save Data
          </v-btn>
        </v-card-actions>
      </v-card>

      <loading :active="loader" :opacity="0.9" color="#ff6b00" />
    </v-card>
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
import commonService from "@/services/CommonService/commonService.js";
import setupService from "@/services/SetupService/setupService";
import { AdditionalCountryInfo } from "@/utils/validation.js";
import { nodotNumber } from "@/utils/validate.js";
import { filterNumberInput } from "@/utils/contactNumber/formatNumber.js";
export default {
  mixins: [alerts],
  components: {
    Loading,
  },
  data() {
    return {
      ...AdditionalCountryInfo,
      filterNumberInput,
      nodotNumber,
      loader: false,
      valid: true,
      payment_mode: "",
      paymentList: [],
      risk_types: [],
      partner_type: "",
      partner_types: [],
      time_zones: [],
      Mandatorycheckskeysvalues: {
        country_code: null,
        country_name: null,
        telephone_code: null,
        iso2: null,
        iso3: null,
        currency_code: null,
        telephone_length_min: null,
        telephone_length_max: null,
        sanction_filter: 0,
        bank_ac_length_min: null,
        bank_ac_length_max: null,
        is_states_mandatory: null,
        is_bb_code_Mandatory: null,
        bb_remarks: "",
        risk_type_code: "",
        time_zone: null,
      },
      mandatoryValues: {
        mode_type: "payment_mode",
        value_list: [],
      },
      mandatoryValuespartners: {
        mode_type: "partner_type",
        value_list: [],
      },
      allFieldsFilled: false,
      dataFetched: false,
    };
  },
  watch: {
    // Mandatorycheckskeysvalues: {
    //   handler(newVal, oldVal) {
    //     console.log("newVal", newVal);
    //     console.log("oldVal", oldVal);
    //     // const validate = this.$refs.form.validate();
    //     // if(validate){
    //     //   this.saveKeyschecks();
    //     // }
    //   },
    //   deep: true,
    // },
    // mandatoryValues: {
    //   handler(newVal, oldVal) {
    //     console.log("newVal", newVal);
    //     console.log("oldVal", oldVal);
    //     this.savePayment();
    //   },
    //   deep: true,
    // },
    // mandatoryValuespartners: {
    //   handler(newVal, oldVal) {
    //     console.log("newVal", newVal);
    //     console.log("oldVal", oldVal);
    //     this.savePartners();
    //   },
    //   deep: true,
    // },
  },
  mounted() {
    const userId = this.$route.query.id;
    console.log("id", userId);
    // if (!this.dataFetched) {
    //   // Trigger GET API call if data has not been fetched
    // }
    this.getTimeZones();
    this.getallKeyschecks();
    this.getallpaymets();
    this.getallpartners();
    this.getparameterdropdowns("PTY");
    this.getparameterdropdowns("RTC");
    this.getparameterdropdowns("PTC");
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    saveMandatory() {
      this.loader = true;
      const validate = this.$refs.form.validate();
      const validateMandatory = this.$refs.Mandatory.validate();
      if (validate & validateMandatory) {
        this.saveKeyschecks();
        this.savePartners();
        this.savePayment();
        // this.showAlertSuccess("Data updated: SUCCESS");
        this.stoploader();
      } else {
        this.showAlertError("Failed: Please enter required feilds");
        this.loader = false;
      }
    },
    async saveKeyschecks() {
      try {
        const responseData = await setupService.saveKeyschecks(
          this.$route.query.id,
          this.Mandatorycheckskeysvalues
        );
        if (responseData && responseData.data.status_code == 200) {
          this.loader = false;
          this.showAlertSuccess(responseData.data.message);
          // this.datapresent = true;
        }
        // else if (responseData.data.status_code == 401) {
        //   this.returnNewToken();
        //   this.saveKeyschecks();
        // }
        else {
          this.showAlertError(` ${responseData.data.message}`);
        }
        console.log("responseData", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getallKeyschecks() {
      try {
        const response = await setupService.getallKeyschecks(
          this.$route.query.id
        );
        if (response.data.status_code === 200) {
          const data = response.data.data[0];
          this.Mandatorycheckskeysvalues.telephone_length_min =
            response.data.data[0].telephone_length_min;
          this.Mandatorycheckskeysvalues.telephone_length_max =
            response.data.data[0].telephone_length_max;
          this.Mandatorycheckskeysvalues.sanction_filter = response.data.data[0]
            .sanction_filter
            ? response.data.data[0].sanction_filter
            : 0;
          this.Mandatorycheckskeysvalues.bank_ac_length_min =
            response.data.data[0].bank_ac_length_min;
          this.Mandatorycheckskeysvalues.bank_ac_length_max =
            response.data.data[0].bank_ac_length_max;
          this.Mandatorycheckskeysvalues.is_states_mandatory =
            response.data.data[0].is_states_mandatory;
          this.Mandatorycheckskeysvalues.is_bb_code_Mandatory =
            response.data.data[0].is_bb_code_Mandatory;
          this.Mandatorycheckskeysvalues.bb_remarks =
            response.data.data[0].bb_remarks;
          this.Mandatorycheckskeysvalues.risk_type_code = response.data.data[0]
            .risk_type_code
            ? response.data.data[0].risk_type_code.value_code
            : "";
          this.Mandatorycheckskeysvalues.time_zone =
            response.data.data[0].time_zone;
          this.Mandatorycheckskeysvalues.country_code =
            response.data.data[0].iso3;
          this.Mandatorycheckskeysvalues.telephone_code =
            response.data.data[0].telephone_code;
          this.Mandatorycheckskeysvalues.iso2 = response.data.data[0].iso2;
          this.Mandatorycheckskeysvalues.iso3 = response.data.data[0].iso3;
          this.Mandatorycheckskeysvalues.currency_code =
            response.data.data[0].currency_code;
          console.log(data);
          this.dataFetched = true;
          console.log(data);
          this.paymetsfetched = true;
        }
        // else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getallKeyschecks();
        // }
        console.log("countrys", response);
      } catch (e) {
        console.error(e);
        this.CountryList = [];
      }
    },
    async savePayment() {
      try {
        const responseData = await setupService.savePayment(
          this.$route.query.id,
          this.mandatoryValues
        );
        if (responseData && responseData.data.status_code == 200) {
          this.loader = false;
          this.showAlertSuccess(responseData.data.message);
          // this.datapresent = true;
        }
        // else if (responseData.data.status_code == 401) {
        //   this.returnNewToken();
        //   this.savePayment();
        // }
        else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        console.log("responseData", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getallpaymets() {
      try {
        const response = await setupService.getallpaymets(this.$route.query.id);
        if (response.data.status_code === 200) {
          const payments = response.data.data[0];
          console.log("payments", payments);
          payments.map((ele) => {
            console.log("ele", ele);
            if (ele.mode_type === "payment_mode") {
              this.mandatoryValues.value_list.push(
                ele.payment_type.payment_mode_code
              );
            }
          });
        }
        // else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getallpaymets();
        // }
        console.log("getallpaymets", response);
      } catch (e) {
        console.error(e);
        this.CountryList = [];
      }
    },

    async savePartners() {
      try {
        const responseData = await setupService.savePartners(
          this.$route.query.id,
          this.mandatoryValuespartners
        );
        if (responseData && responseData.data.status_code == 200) {
          this.loader = false;
          this.showAlertSuccess(responseData.data.message);
          // this.datapresent = true;
        }
        // else if (responseData.data.status_code == 401) {
        //   this.returnNewToken();
        //   this.savePayment();
        // }
        else {
          this.showAlertError(` ${responseData.data.message}`);
        }
        console.log("responseData", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getallpartners() {
      try {
        const response = await setupService.getallpartners(
          this.$route.query.id
        );
        if (response.data.status_code === 200) {
          const partners = response.data.data[0];
          partners.map((ele) => {
            console.log("ele", ele);
            if (ele.mode_type === "partner_type") {
              this.mandatoryValuespartners.value_list.push(
                ele.payment_type.value_code
              );
            }
          });
          console.log(partners);
          this.paymetsfetched = true;
        }
        //  else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getallpartners();
        // }
        console.log("countrys", response);
      } catch (e) {
        console.error(e);
        this.CountryList = [];
      }
    },

    async getparameterdropdowns(code) {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getparameterdropdowns(code);
        if (response.data.status_code === 200) {
          switch (code) {
            case "PTY":
              console.log("PTY codes", response.data.data);
              this.paymentList = response.data.data.map((i) => {
                return { txt: i.value, val: i.value_code };
              });
              break;
            case "RTC":
              console.log("RTC codes", response.data.data);
              this.risk_types = response.data.data.map((i) => {
                return { txt: i.value, val: i.value_code };
              });
              break;
            case "PTC":
              console.log("PTC codes", response.data.data);
              this.partner_types = response.data.data.map((i) => {
                return { txt: i.value, val: i.value_code };
              });
              break;
          }
        }
        //  else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getparameterdropdowns(code);
        // }
      } catch (error) {
        this.transItems = [];

        console.error(error);
      }
    },
    async getTimeZones() {
      try {
        const responseData = await commonService.gettimeZone();
        if (responseData && responseData.data.status_code == 200) {
          console.log(responseData);
          this.time_zones = responseData.data.data;
        }
        // else if (responseData.data.status_code == 401) {
        //   this.returnNewToken();
        //   this.getTimeZones();
        // }
        console.log("responseData", responseData);
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
.green {
  color: red !important;
}
.v-messages {
  min-height: 0px !important;
}
.cardtext-width {
  max-width: 900px !important;
  margin: auto;
}
</style>
